import { render, staticRenderFns } from "./CIVesselList.vue?vue&type=template&id=0fa64ccf&scoped=true&"
import script from "./CIVesselList.vue?vue&type=script&lang=js&"
export * from "./CIVesselList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa64ccf",
  null
  
)

export default component.exports